import { Dialog, Button } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from 'tss-react/mui';
import HourglassFull from '@mui/icons-material/HourglassFull';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DIALOG } from '../../theme/constants';

const styles = () => ({
  dialogContentWithNewLines: {
    whiteSpace: 'pre-wrap',
    minWidth: '300px',
  },
  sentimentIcon: {
    fontSize: '60px',
  },
  sentimentIconWrap: {
    textAlign: 'center',
  },
});
let loadingTimeout = {};

const LoaderTimeout = ({ loading, classes }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    clearTimeout(loadingTimeout);

    if (loading === true) {
      loadingTimeout = setTimeout(() => {
        setDialogOpen(true);
      }, 199000);
    }

    return () => clearTimeout(loadingTimeout);
  }, [loading]);

  const homeClick = () => {
    navigate('/');
    setDialogOpen(false);
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog open={dialogOpen} onClose={handleClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">{DIALOG.LOADING_TIMEOUT_TITLE}</DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.dialogContentWithNewLines}>
          {DIALOG.TIMEOUT_TEXT}
          <br />
        </DialogContentText>
        <div className={classes.sentimentIconWrap}>
          <br />
          <HourglassFull color="disabled" className={classes.sentimentIcon} />
        </div>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={homeClick}>
          Home
        </Button>
        <Button color="primary" onClick={handleClose}>
          Keep waiting
        </Button>
      </DialogActions>
    </Dialog>
  );
};

LoaderTimeout.propTypes = {
  loading: PropTypes.bool.isRequired,
  classes: PropTypes.object,
};

export default withStyles(LoaderTimeout, styles);
